import { ReactNode } from 'react';

import { AutoscalerFeatures } from '@cast/types';

import { useAutoscalerFeaturesQuery } from 'hooks/queries/autoscaler';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type Feature = Extract<
  keyof AutoscalerFeatures,
  | 'arm64Supported'
  | 'enableDefaultNodeTemplate'
  | 'reservationsEnabled'
  | 'windowsAutoscalingEnabled'
  | 'karpenterInstalled'
>;

type Props = {
  feature: Feature | Array<Feature>;
  children: (() => ReactNode) | ReactNode;
  fallback?: ReactNode;
};
const renderContent = (
  featureEnabled: boolean,
  fallback: ReactNode,
  children: ReactNode | (() => ReactNode)
) => {
  if (featureEnabled) {
    if (typeof children === 'function') {
      return <>{children()}</>;
    }
    return <>{children}</>;
  }
  return <>{fallback}</>;
};

export const WhenAvailable = ({
  feature,
  children,
  fallback = null,
}: Props) => {
  const { cluster } = useCluster();
  const { features } = useAutoscalerFeaturesQuery(cluster.id);

  if (Array.isArray(feature)) {
    if (feature.every((f) => !!features?.[f])) {
      if (typeof children === 'function') {
        return <>{children()}</>;
      }
      return <>{children}</>;
    }
    return <>{fallback}</>;
  }
  const featureEnabled = !!features?.[feature];

  return renderContent(featureEnabled, fallback, children);
};
